export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export const RESIZE_SCREEN = 'RESIZE_SCREEN';
export const SET_ORIENTATION = 'SET_ORIENTATION';

export const ME = 'ME';
export const LOGOUT = 'LOGOUT';

export const FETCH_STORIES = 'FETCH_STORIES';
export const FETCH_SELECTED_STORY = 'FETCH_SELECTED_STORY';
export const FETCH_MOMENTS = 'FETCH_STORY_MOMENTS';
export const FETCH_STORY = 'FETCH_STORY';
export const FETCH_ACCOUNT_SETTINGS = 'FETCH_ACCOUNT_SETTINGS';
export const FETCH_STRIPE_SETTINGS = 'FETCH_STRIPE_SETTINGS';

export const HIDE_NAV_BAR = 'HIDE_NAV_BAR';
export const SHOW_NAV_BAR = 'SHOW_NAV_BAR';
export const NAV_BAR_HOME = 'NAV_BAR_HOME';
export const NAV_BAR_STORY = 'NAV_BAR_STORY';
export const NAV_BAR_PRINT_STORE = 'NAV_BAR_PRINT_STORE';
export const NAV_BAR_MODAL = 'NAV_BAR_MODAL';
export const NAV_BAR_FEED = 'NAV_BAR_FEED';

export const SET_PHOTOSWIPE_OPEN = 'SET_PHOTOSWIPE_OPEN';
export const SET_PHOTOSWIPE_INDEX = 'SET_PHOTOSWIPE_INDEX';
export const SET_PHOTOSWIPE_MOMENT_ID = 'SET_PHOTOSWIPE_MOMENT_ID';
export const SET_PHOTOSWIPE_MOMENT = 'SET_PHOTOSWIPE_MOMENT';
export const SET_PHOTOSWIPE_ITEMS = 'SET_PHOTOSWIPE_ITEMS';
export const ADD_PHOTOSWIPE_ITEMS = 'ADD_PHOTOSWIPE_ITEMS';
export const CLEAR_PHOTOSWIPE_ITEMS = 'CLEAR_PHOTOSWIPE_ITEMS';

export const ENABLE_SELECTION = 'ENABLE_SELECTION';
export const DISABLE_SELECTION = 'DISABLE_SELECTION';
export const CLEAR_SELECTION_ITEMS = 'CLEAR_SELECTION_ITEMS';
export const ADD_SELECTION_ITEMS = 'ADD_SELECTION_ITEMS';
export const SELECT_ITEM = 'SELECT_ITEM';
export const UNSELECT_ITEM = 'UNSELECT_ITEM';
export const SELECT_ALL = 'SELECT_ALL';
export const UNSELECT_ALL = 'UNSELECT_ALL';

export const SET_PROGRESS_BAR_VISIBLE = 'SET_PROGRESS_BAR_VISIBLE';
export const SET_PROGRESS_BAR_TOTAL = 'SET_PROGRESS_BAR_TOTAL';
export const SET_PROGRESS_BAR_PROGRESS = 'SET_PROGRESS_BAR_PROGRESS';
export const SET_PROGRESS_BAR_MESSAGE = 'SET_PROGRESS_BAR_MESSAGE';
export const RESET_PROGRESS_BAR = 'RESET_PROGRESS_BAR';

export const OPEN_STORY = 'OPEN_STORY';
export const OPEN_CART_STORY = 'OPEN_CART_STORY';
export const CLOSE_STORY = 'CLOSE_STORY';
export const SET_DEEPLINK_STORY_ID = 'SET_DEEPLINK_STORY_ID';

export const SET_DATES = 'SET_DATES';
export const SET_SELECTED_DATE = 'SET_SELECTED_DATE';

export const FETCH_CART_MOMENTS = 'FETCH_CART_MOMENTS';
export const ADD_CART_MOMENT = 'ADD_CART_MOMENT';
export const FETCH_CART_SELECTIONS = 'FETCH_CART_SELECTIONS';

export const SELECT_CART_MOMENTS = 'SELECT_CART_MOMENTS';
export const UNSELECT_CART_MOMENTS = 'UNSELECT_CART_MOMENTS';
export const REMOVE_CART_MOMENT = 'REMOVE_CART_MOMENT';
export const SELECT_PRINTS = 'SELECT_PRINTS';
export const UNSELECT_PRINTS = 'UNSELECT_PRINTS';

export const SET_PURCHASE_REQUEST = 'SET_PURCHASE_REQUEST';
export const CLEAR_PURCHASE_REQUEST = 'CLEAR_PURCHASE_REQUEST';

export const FETCH_PURCHASES = 'FETCH_PURCHASES';
export const FETCH_PRINTS = 'FETCH_PRINTS';
export const FETCH_PURCHASED_MOMENT_IDS = 'FETCH_PURCHASED_MOMENT_IDS';
export const SET_PURCHASED = 'SET_PURCHASED';
export const NEW_ORDER = 'NEW_ORDER';
export const FETCH_PURCHASE_CALCULATIONS = 'FETCH_PURCHASE_CALCULATIONS';
export const ADD_PURCHASE = 'ADD_PURCHASE';

export const SHOW_TERMS = "SHOW_TERMS";
export const SHOW_HOME = 'SHOW_HOME';
export const SHOW_LOADING = "SHOW_LOADING";
export const GET_ACCESS_CODE = "GET_ACCESS_CODE";

export const SET_UPPERCASE_LABELS = 'SET_UPPERCASE_LABELS';
export const SHOW_RECEIPT = 'SHOW_RECEIPT';

export const SHOW_PROFILE = 'SHOW_PROFILE';
export const SHOW_STORY = 'SHOW_STORY';
export const SHOW_CONTACT_US = 'SHOW_CONTACT_US';
export const SHOW_DELETE_MY_ACCOUNT = 'SHOW_DELETE_MY_ACCOUNT';
export const SHOW_TERMS_OF_USE = 'SHOW_TERMS_OF_USE';

export const SET_AS_MOBILE_CART = "SET_AS_MOBILE_CART";
export const SHOW_MOBILE_CART_PREMIUM_GALLERY = "SHOW_MOBILE_CART_PREMIUM_GALLERY";
export const PREMIUM_GALLERY_LOADED = 'PREMIUM_GALLERY_LOADED';
export const SHOW_CHECKOUT_FORM = "SHOW_CHECKOUT_FORM";

export const SET_PURCHASING_LOADING = 'SET_PURCHASING_LOADING';

export const APPLY_DISCOUNT_COUPON = 'APPLY_DISCOUNT_COUPON';

export const SELECT_LOCALE = 'SELECT_LOCALE';
export const SET_PRINT_SIZES = 'SET_PRINT_SIZES';
export const GET_SELECTED_PRINT_SIZES = 'GET_SELECTED_PRINT_SIZES';
export const CLEAR_SELECTED_PRINT_SIZES = 'CLEAR_SELECTED_PRINT_SIZES';
export const SHOW_AUTHORIZE_KNOCKOUT = 'SHOW_AUTHORIZE_KNOCKOUT';
export const RE_KNOCKOUT_MOMENT = 'RE_KNOCKOUT_MOMENT';
export const SHOW_CROP_MOMENT = 'SHOW_CROP_MOMENT';
export const CREATE_STRIPE_PAYMENT_INTENT = 'CREATE_STRIPE_PAYMENT_INTENT';
export const CLEAR_STRIPE_PAYMENT_INTENT = 'CLEAR_STRIPE_PAYMENT_INTENT';
export const REGISTER_STRIPE_READER = 'REGISTER_STRIPE_READER';
export const UPDATE_STRIPE_READER_STATUS = 'UPDATE_STRIPE_READER_STATUS';
export const GET_MARKETING_BY_JOB = 'GET_MARKETING_BY_JOB';
export const SHOW_MARKETING = 'SHOW_MARKETING';
export const GET_KIOSK_PRICINGS = "GET_KIOSK_PRICINGS";
export const CREATE_KIOSK_PRICING = "CREATE_KIOSK_PRICING";
export const UPDATE_KIOSK_PRICING = "UPDATE_KIOSK_PRICING";
export const SET_DRAGGABLE_IMAGE = "SET_DRAGGABLE_IMAGE";

export const UPDATE_ACCOUNT_PIN = 'UPDATE_ACCOUNT_PIN';
export const UPDATE_USERNAME = 'UPDATE_USERNAME';
export const REVIEW_CART = 'REVIEW_CART';